import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const AccessibilityStatement = () => {
  return (
    <>
      <Helmet>
        <title>Accessibility - Ganda Sushi</title>
      </Helmet>

      <main className="bg-luxury-cream text-luxury-dark pt-40 pb-24">
        <section className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="prose prose-gold max-w-none"
          >
            <h1 className="text-5xl font-serif text-luxury-gold mb-12 uppercase tracking-tight">Accessibility</h1>
            <p className="text-luxury-dark/60 italic mb-12 border-l-2 border-luxury-gold pl-6">Last Updated: January 27, 2025</p>

            <div className="space-y-12 text-luxury-dark/70 leading-relaxed font-light">
              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">Our Commitment</h2>
                <p>
                  Ganda Sushi is dedicated to ensuring our culinary experience is accessible to all individuals. We strive to provide an inclusive environment both in our physical restaurant and across our digital platforms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">Digital Standards</h2>
                <p>
                  Our website is designed to meet WCAG 2.1 Level AA standards, incorporating features such as keyboard navigation, screen reader support, and high-contrast visuals.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">Contact Support</h2>
                <p>
                  Should you encounter any challenges accessing our services, please contact us at (718) 380-1818. Our team is ready to provide personalized assistance.
                </p>
              </section>
            </div>
          </motion.div>
        </section>
      </main>
    </>
  );
};

export default AccessibilityStatement;